import React from "react";
import EmandateInfoPage from "../Mandate/EmandateInfoPage";
import pauseSip from "@frameworks/shared-library/assets/images/SalesJourney/pause-sip.svg";
var PauseOrder = function (props) {
    return (React.createElement("div", { className: "parent-order-info-container commonscroll align-content-space-around " },
        React.createElement("main", { className: "d-flex flex-column align-items-center status-container" },
            React.createElement("div", { className: "d-flex flex-column align-items-center gap-4" },
                React.createElement(EmandateInfoPage, { iconSrc: pauseSip, title: "Do you want to pause this SIP?", description: "This SIP can be paused for a maximum of ".concat(props.minInstallmentPause, " installments.") })))));
};
export default PauseOrder;
